import { Link } from 'react-router-dom'

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center bg-background-50 overflow-hidden" aria-labelledby="hero-title">
      <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle at 50% 50%, oklch(var(--primary-100) / 0.15) 0%, transparent 50%)' }}></div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 pt-24 pb-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

          {/* 左侧文本区 - 入场动画 */}
          <div className="flex-1 w-full lg:w-1/2 space-y-6 animate-[fadeSlideUp_0.8s_cubic-bezier(0.25,0.46,0.45,0.94)_0.1s_both]">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100/70 rounded-full animate-[fadeSlideUp_0.6s_cubic-bezier(0.25,0.46,0.45,0.94)_0.2s_both]">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs font-medium text-primary-700">每日更新 · 正版高清</span>
            </div>

            <h1 id="hero-title" className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-foreground-950 leading-[1.08] tracking-tight animate-[fadeSlideUp_0.7s_cubic-bezier(0.25,0.46,0.45,0.94)_0.3s_both]">
              <span className="font-normal">发现你的</span>
              <br />
              下一部本命韩漫
            </h1>

            <p className="text-sm md:text-base text-foreground-600 max-w-lg leading-relaxed animate-[fadeSlideUp_0.7s_cubic-bezier(0.25,0.46,0.45,0.94)_0.45s_both]">
              汇聚韩国顶级漫画作品，从浪漫BL到热血动作，每日同步更新最新章节。正版授权，高清画质，极速加载，给你最纯粹的韩漫阅读体验。
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 pt-2 animate-[fadeSlideUp_0.6s_cubic-bezier(0.25,0.46,0.45,0.94)_0.55s_both]">
              <Link
                to="/category/romance"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 hover:shadow-[0_4px_20px_-4px_oklch(var(--primary-500)/0.4)] hover:-translate-y-0.5 active:translate-y-0 transition-all duration-300 whitespace-nowrap cursor-pointer group"
              >
                浏览全部分类
                <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform duration-200">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-foreground-700 hover:text-foreground-900 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                了解更多
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-information-line"></i>
                </span>
              </Link>
            </div>

            <div className="flex items-center gap-6 pt-6 animate-[fadeSlideUp_0.7s_cubic-bezier(0.25,0.46,0.45,0.94)_0.65s_both]">
              <div className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">10,000+</p>
                <p className="text-xs text-foreground-500 mt-0.5">部签约作品</p>
              </div>
              <div className="w-px h-10 bg-foreground-200"></div>
              <div className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">500万</p>
                <p className="text-xs text-foreground-500 mt-0.5">日活读者</p>
              </div>
              <div className="w-px h-10 bg-foreground-200"></div>
              <div className="text-center">
                <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">99.8%</p>
                <p className="text-xs text-foreground-500 mt-0.5">好评率</p>
              </div>
            </div>
          </div>

          {/* 右侧图片区 - 入场动画 */}
          <div className="flex-1 w-full lg:w-1/2 relative animate-[fadeSlideRight_0.8s_cubic-bezier(0.25,0.46,0.45,0.94)_0.3s_both]">
            <div className="relative rounded-3xl overflow-hidden group" style={{ height: '420px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20collage%20art%2C%20multiple%20comic%20covers%20arranged%20creatively%2C%20vibrant%20colors%20with%20pink%20and%20coral%20accents%2C%20clean%20minimal%20composition%2C%20flat%20lay%20style%2C%20soft%20shadows%2C%20artistic%20arrangement%2C%20modern%20digital%20illustration%20aesthetic%2C%20warm%20atmosphere%2C%20ivory%20background&width=1200&height=840&seq=hero-banner-01&orientation=landscape"
                alt="韩漫热门作品封面展示"
                className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-700 ease-out"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-background-50/40 via-transparent to-transparent"></div>
            </div>

            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-[90%] animate-[fadeSlideUp_0.6s_cubic-bezier(0.25,0.46,0.45,0.94)_0.7s_both]">
              <div className="bg-background-50/95 backdrop-blur-md rounded-full px-5 py-3 border border-background-200/60 flex items-center gap-3 hover:shadow-[0_4px_24px_-6px_rgba(0,0,0,0.08)] transition-shadow duration-300">
                <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
                  <i className="ri-search-line text-sm"></i>
                </span>
                <input
                  type="text"
                  placeholder="搜索你喜欢的韩漫作品..."
                  className="flex-1 bg-transparent text-sm text-foreground-700 placeholder:text-foreground-400 focus:outline-none"
                />
                <button className="px-4 py-1.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full hover:bg-primary-600 hover:shadow-[0_4px_16px_-4px_oklch(var(--primary-500)/0.5)] active:scale-95 transition-all duration-200 whitespace-nowrap cursor-pointer">
                  搜索
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}